import { EmailAvailabilityPayload } from 'models/endpoints-payload'
import { EmailAvailabilityResponse } from 'models/endpoints-respone'
import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_IK: string

export const checkEmailAvailability = (payload: EmailAvailabilityPayload): Promise<EmailAvailabilityResponse> => {
  return promiseWrapper<EmailAvailabilityResponse, EmailAvailabilityPayload>(
    `${USER_BASE_URL_IK}/api/public/emailAvailable/${payload.email}`,
    'GET',
  )
}
